import { Box, Divider } from '@mui/material';
import PersonalInformation from './components/PersonalInformation/PersonalInformation';
import DeleteAccount from './components/DeleteAccount/DeleteAccount';
import ChangeEmail from './components/ChangeEmail/ChangeEmail';
import ResetPassword from './components/ResetPassword/ResetPassword';

const AccountSettings = () => {
  return (
    <Box px="32px">
      <PersonalInformation />
      <Divider />
      <ChangeEmail />
      <Divider />
      <ResetPassword />
      <Divider />
      <DeleteAccount />
    </Box>
  );
};

export default AccountSettings;
